import { render } from "./TextTile.vue?vue&type=template&id=380af38a"
import script from "./TextTile.vue?vue&type=script&lang=js"
export * from "./TextTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__